import { Card } from "@/components/ui/card";
import AuthLayout from "../auth-layout";
import { NewPasswordForm } from "./components/new-password-form";

interface NewPasswordProps {
  isSuperadmin: boolean;
}

export default function NewPassword({ isSuperadmin }: NewPasswordProps) {
  return (
    <AuthLayout>
      <Card className="p-6">
        <div className="mb-2 flex flex-col space-y-2 text-left">
          <h1 className="text-md font-semibold tracking-tight">
            Change Password Required
          </h1>
          <p className="text-muted-foreground text-sm">
            You need to change your password before continuing. Please enter a
            new password below.
          </p>
        </div>
        <NewPasswordForm isSuperadmin={isSuperadmin} />
      </Card>
    </AuthLayout>
  );
}
